
import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/auth/AuthContext';
import { useLogout } from '@/hooks/useLogout';

interface LogoutButtonProps {
  variant?: 'mobile' | 'desktop';
  className?: string;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ variant = 'desktop', className = '' }) => {
  const { currentUser } = useAuth();
  const { handleLogout } = useLogout();

  if (!currentUser) return null;

  if (variant === 'mobile') {
    return (
      <Button
        variant="ghost"
        size="sm"
        onClick={handleLogout}
        className={`h-10 w-10 p-0 hover:bg-destructive/10 ${className}`}
        aria-label="Log out"
      >
        <LogOut className="h-5 w-5" />
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleLogout}
      className={`flex items-center gap-2 hover:bg-destructive/10 ${className}`}
    >
      <LogOut className="h-4 w-4" />
      <span>Log out</span>
    </Button>
  );
};

export default LogoutButton;
